import React from 'react';
import { Link } from 'react-router-dom';

const links = [
  { href: '/about', text: 'About Us' },
  { href: '/teachers', text: 'Find Teachers' },
  // { href: '/become-teacher', text: 'Become a Teacher' },
  { href: '/help', text: 'Contact Us' },
];

const QuickLinks = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
      <ul className="space-y-2">
        {links.map((link) => (
          <li key={link.href}>
            <Link
              to={link.href}
              className="text-gray-400 hover:text-white transition-colors"
            >
              {link.text}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickLinks;
